<template>
  <div>
    <div class="matrix-scale" v-for="(rowItem, id) in getRows().resRows" :key="id">
      <div v-show="rowNum < id + 1" class="is-del">
        <i @click="deleteRow(rowItem)" class="el-icon-delete"></i>
      </div>
      <template v-for="(col, idx) in dataList.questionDetails.issue.items">
        <div class="flex justify-start">
          <h5
            class="flex-shrink-0"
            style="max-width: 120px"
            v-html="transformHtml(col.content.richText || col.content.text)"
          ></h5>
          <!-- <div style="display:inline-block;margin-right:5px;" v-show="getImg(col)" v-for="(image,ix) in getImg(col)" :key="ix">
            <el-image
            style="width: 30px; height: 30px;"
            :z-index="5000"
            :src="image"
            :preview-src-list="getImg(col)"
            />
          </div> -->
          <el-select
            v-if="dataList.questionDetails.issue.cells[idx].cell_type == 12"
            v-model="getMatrixSelect(rowItem, col).model"
            placeholder="请选择"
            @change="changeMatrixSelect($event, rowItem, col)"
          >
            <el-option
              v-for="item in getMatrixSelect(rowItem, col).options"
              :key="item.id"
              :label="item.content.text"
              :value="item.id"
            >
              <template>
                <el-tooltip
                  :disabled="item.content.text < 22"
                  class="tooltip-style"
                  effect="light"
                  :content="item.content.text"
                  placement="top"
                >
                  <span style="max-width: 350px; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{
                    item.content.text
                  }}</span>
                </el-tooltip>
              </template>
            </el-option>
          </el-select>
          <el-input
            v-else
            v-model="getMatrixInput(rowItem, col).model"
            placeholder="请填写"
            @input="changeMatrixInput($event, rowItem, col)"
          >
          </el-input>
        </div>
      </template>
      <hr v-show="!(id + 1 == getRows().resRows.length)" style="border: 1px dashed #ccc; height: 1px; margin: 5px 0" />
      <div
        v-show="id == getRows().resRows.length - 1 && id != dataList.questionDetails.issue.max_row_num - 1"
        style="width: 100%; text-align: center; margin: 10px 0"
      >
        <el-button @click="addData(dataList, rowItem)" size="mini">继续添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveArr } from '../public/index.js'
import '../public/style.css'
import { itemInitOptions } from '../config/config.js'
import mixins from '../mixins'

export default {
  mixins: [mixins],
  name: 'MatirxAuto',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dataList: [],
      rowNum: null
    }
  },
  created() {
    this.initData()
    this.handleRowNum()
    this.dataList = Object.assign({}, this.rowData)
  },
  computed: {
    getMatrixSelect() {
      return function (rowItem, col) {
        const cells = this.dataList.questionDetails.issue.cells // 选项
        const modelId = this.dataList.items.find(item => {
          return item.rowId == rowItem && item.colId === col.id
        })
        const options = cells.find(it => {
          return it.col_id === col.id
        }).items
        let model = modelId ? modelId.optionId : ''
        return { model, options }
      }
    },
    // 矩阵填空 v-model
    getMatrixInput() {
      return function (rowItem, col) {
        let valueItem = this.dataList.items.find(item => {
          return item.rowId == rowItem && item.colId === col.id
        })
        let model = valueItem ? valueItem.value : ''
        return { model }
      }
    }
  },
  inject: ['transformHtml'],
  methods: {
    changeMatrixInput(val, rowItem, col) {
      const matchAnswer = this.dataList.items.find(item => {
        return item.colId === col.id && item.rowId == rowItem
      })
      if (matchAnswer) {
        matchAnswer.value = val
      } else {
        this.dataList.items.push(
          Object.assign({}, itemInitOptions, {
            colId: col.id,
            rowId: rowItem,
            value: val
          })
        )
      }
      // let ids = this.updateArr.indexOf(this.dataList)
      // if (ids === -1) {
      //   this.updateArr.push(this.dataList)
      // }
      this.saveArr(this.dataList)
    },
    // 矩阵下拉题 change事件
    changeMatrixSelect(val, rowItem, col) {
      const optionName = this.dataList.questionDetails.issue.cells
        .find(item => {
          return item.col_id === col.id
        })
        .items.find(ci => {
          return ci.id === val
        }).content.text
      let matchAnswer = this.dataList.items.find(item => {
        return item.colId === col.id && item.rowId == rowItem
      })
      if (matchAnswer) {
        matchAnswer.optionId = val
        matchAnswer.value = optionName
      } else {
        this.dataList.items.push(
          Object.assign({}, itemInitOptions, {
            colId: col.id,
            rowId: rowItem,
            optionId: val,
            value: optionName
          })
        )
      }
      // let ids = this.updateArr.indexOf(this.dataList)
      // if (ids === -1) {
      //   this.updateArr.push(this.dataList)
      // }
      this.saveArr(this.dataList)
    },
    getRows() {
      let resRows = []
      this.dataList.items.forEach(item => {
        !resRows.includes(item.rowId) && resRows.push(item.rowId)
      })
      return { resRows }
    },
    addData(row, rowItem) {
      row.questionDetails.issue.items.forEach(ele => {
        row.items.push(
          Object.assign({}, itemInitOptions, {
            colId: ele.id,
            rowId: (1 + parseInt(rowItem)).toString()
          })
        )
      })
      // let ids = this.updateArr.indexOf(this.dataList)
      // if (ids === -1) {
      //   this.updateArr.push(this.dataList)
      // }
      this.saveArr(this.dataList)
    },
    deleteRow(rowItem) {
      this.dataList.items = this.dataList.items.filter(item => {
        return item.rowId != rowItem
      })
    },
    initData() {
      // 没有答案时
      if (this.rowData.items.length == 0) {
        for (let i = 0; i < this.rowData.questionDetails.issue.default_row_num; i++) {
          this.rowData.questionDetails.issue.items.forEach(ele => {
            this.rowData.items.push(
              Object.assign({}, itemInitOptions, {
                colId: ele.id,
                rowId: (i + 1).toString()
              })
            )
          })
        }
      } else if (
        Math.ceil(this.rowData.items.length / this.rowData.questionDetails.issue.items.length) <
        this.rowData.questionDetails.issue.min_row_num
      ) {
        // 答案行数比至少行少时
        for (
          let i = Math.ceil(this.rowData.items.length / this.rowData.questionDetails.issue.items.length);
          i < this.rowData.questionDetails.issue.min_row_num;
          i++
        ) {
          this.rowData.questionDetails.issue.items.forEach(ele => {
            this.rowData.items.push(
              Object.assign({}, itemInitOptions, {
                colId: ele.id,
                rowId: (i + 1).toString()
              })
            )
          })
        }
      }
    },
    getImg(item) {
      var answerArr = []
      if (item && item.content && item.content.image && item.content.image[0]) {
        item.content.image.forEach(element => {
          answerArr.push(this._getDownloadUrl(element.url))
        })
      }
      return answerArr
    },
    saveArr,
    handleRowNum() {
      this.rowNum = Math.ceil(this.rowData.items.length / this.rowData.questionDetails.issue.items.length)
    }
  },
  watch: {
    rowData(n) {
      this.dataList = n
      this.handleRowNum()
    }
  }
}
</script>

<style lang="scss" scoped>
.is-del {
  text-align: right;
  i {
    cursor: pointer;
  }
  i:hover {
    color: #0086b3;
  }
}
</style>
